export class TrixHelper {
  // @param {DOMRect} objectPosition
  static renderDialog(objectPosition) {
    let node = document.createElement("div")
    node.id = "trix-link-dialog"
    node.style.position = "absolute"
    node.style.display = "block"
    node.style.marginLeft = 0
    node.style.marginTop = 0
    node.style.top = Math.round(objectPosition.height + 15) + "px"
    node.style.left = -5 + "px"
    return node
  }
}
